export enum ActivityTab {
  All = 'all',
  Chat = 'chat',
  Comments = 'comment',
  Other = 'other',
}
